var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jyvl3k4f7b",
    width: "116.7%",
    height: "116.7%",
    x: "-8.3%",
    y: "-8.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0.76452106 0 0 0 0 0.248180456 0 0 0 0 0.049720091 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "mlvi8sq04a",
    cx: 24,
    cy: 24,
    r: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1103 -603) translate(990 515) translate(113 88)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.813 5.813)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFDA46",
    xlinkHref: "#mlvi8sq04a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#jyvl3k4f7b)",
    xlinkHref: "#mlvi8sq04a"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.563,
    cy: 28.688,
    fill: "#59391F",
    rx: 3.188,
    ry: 5.063,
    transform: "rotate(10 21.563 28.688)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.063,
    cy: 28.688,
    fill: "#59391F",
    rx: 3.188,
    ry: 5.063,
    transform: "rotate(-10 38.062 28.687)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#308AFC",
    fillRule: "nonzero",
    d: "M8.782 45.244c-1.814-1.814-1.814-4.755 0-6.57 2.708-2.707 8.391-3.927 10.305-4.272.317-.057.594.22.537.537-.345 1.914-1.565 7.597-4.272 10.305-1.814 1.814-4.756 1.814-6.57 0z",
    transform: "rotate(-20 13.527 40.5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59391F",
    strokeLinecap: "round",
    strokeWidth: 2.25,
    d: "M25.125 14.063L18 18.938"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59391F",
    strokeLinecap: "round",
    strokeWidth: 2.25,
    d: "M41.625 14.063L34.5 18.938",
    transform: "matrix(-1 0 0 1 76.125 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59391F",
    strokeLinecap: "round",
    strokeWidth: 2.25,
    d: "M22.5 40.5c1.999-3.625 4.521-5.438 7.567-5.438 3.046 0 5.711 1.813 7.995 5.438"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSad);
export default __webpack_public_path__ + "static/media/emoji-sad.f87ffcc4.svg";
export { ForwardRef as ReactComponent };